const InsuranceChallenge1InitialText ="Life is full of surprises and some of them come with a big price " +
    "tag. That's where insurance comes in. Below are some real-life scenarios that could happen to anyone. " +
    "Drag each one to the type of insurance that would help cover the cost, or to 'Not Covered' if none " +
    "of these policies would apply.  Click the 'Done' button when you have finished sorting all of the " +
    "items."

export default InsuranceChallenge1InitialText 
